module.exports = __webpack_public_path__ + "img/file-music.c9b8eda8.svg";